<template>
  <div class="sac-color-picker-container">
    <button
      class="sac-picker-button"
      @click="toggleShow"
    >
      <div class="sac-color-code">
          {{ color }}
      </div>
      <div
        class="sac-sample-block"
        :style="sampleStyles"
      />
    </button>
    <div
      :class="[
        showPicker && 'show',
        'sac-picker-container',
      ]"
    >
      <Chrome
        :value="color"
        @input="({ hex }) => change(hex)"
      />
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
  name: 'SACColorPicker',
  components: {
    Chrome,
  },
  props: {
    color: String,
    change: Function,
    disable: Boolean,
  },
  data() {
    return {
      selectedColor: '',
      showPicker: false,
    };
  },
  computed: {
    sampleStyles() {
      return {
        width: '20px',
        height: '20px',
        'background-color': this.color,
      };
    },
  },
  mounted() {
    this.selectedColor = this.color;
    document.querySelector(':not(.sac-picker-container)').addEventListener('click', this.closeOnClick);
  },
  destroyed() {
    document.querySelector(':not(.sac-picker-container)').removeEventListener('click', this.closeOnClick);
  },
  methods: {
    toggleShow() {
      if (!this.disable) {
        this.showPicker = !this.showPicker;
      }
    },
    closeOnClick(e) {
      if (!e.target.closest('.sac-color-picker-container') && this.showPicker) {
        this.showPicker = false;
      }
    },
  },
};
</script>

<style lang="scss">

.sac-color-picker-container {
  position: relative;
  .sac-picker-button {
    display: flex;
    align-items: center;
    padding: 12px 12px;
    width: 150px;
    background-color: #F6F6F7;
    border-radius: 4px;
    .sac-color-code {
      font-weight: 500;
      flex: 1;
      text-align: start;
      color: $N60;
    }
  }
  .sac-picker-container {
    position: absolute;
    right: 0;
    bottom: 50px;
    display: none;
    &.show {
      display: block;
    }
  }
}
</style>
